import React, { forwardRef, useImperativeHandle, useRef } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import PayForm from "../Forms/PayForm";
import EngineerPayForm from "../Forms/EngineerPayForm";
import useAuth from "../../../hooks/useAuth";
import { useHasAcceptedProposal } from "../../../hooks/useHasAcceptedProposal";
import { CUSTOMER_PO_ONLY_EDITABLE_STATUSES, UserType } from "../../../utils/enum";
import { combineValidationResults } from "../../../utils/formErrors";

const WorkPay = forwardRef((props, ref) => {
  const { authRole } = useAuth();
  const isCustomer = authRole === UserType.CUSTOMER;
  const currentStatus = useSelector((state) => state.workOrder.status);
  // Editing a ticket whose proposal the customer accepted: the agreed payment is final
  // for them (the API drops it from their update too).
  const { id: workOrderId } = useParams();
  const hasAcceptedProposal = useHasAcceptedProposal(workOrderId, isCustomer);
  const isPOOnly =
    isCustomer &&
    (CUSTOMER_PO_ONLY_EDITABLE_STATUSES.includes(currentStatus) || hasAcceptedProposal);
  const paymentRef = useRef();
  const engineerPaymentRef = useRef();
  useImperativeHandle(ref, () => ({
    isValid: () =>
      combineValidationResults(
        paymentRef.current?.isValid?.(),
        engineerPaymentRef.current?.isValid?.(),
      ),
  }));
  return (
    <div>
      {/* Customers only set their own (customer) rates — engineer pay is hidden. */}
      <PayForm ref={paymentRef} disableRateFields={isPOOnly} disableExpenses={isPOOnly} />
      {!isCustomer && <EngineerPayForm ref={engineerPaymentRef} />}
      {/* <CustomFieldsForm /> */}
    </div>
  );
});

export default WorkPay;
